"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = AssistantProvider;
exports.useAssistant = void 0;
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("@assistant-ui/react");
var _constants = require("./constants");
var _AssistantResponseTexts = require("./AssistantResponseTexts");
var _threadStore = require("./threadStore");
var _api = require("./api");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const INCIDENT_PROMPTS = {
  TRIGGER: 'Get Incident Analysis & Recommendations'
};
const DATA_RETRIEVAL_PROMPTS = {
  TRIGGER: 'Get Record/Aggregate Data Across Systems',
  CDC: 'Get CDC Record',
  USER_SERVICE: 'Get User Service Data',
  DYNAMO: 'Get DynamoDB Record',
  GRAPHQL: 'Get GraphQL Data',
  DYNAMO_PATIENT: 'Get Patient Record',
  DYNAMO_AGGREGATE: 'Get Aggregate Record',
  DYNAMO_RECORD_AUX: 'Get Record Aux Record',
  DYNAMO_AGGREGATE_AUX: 'Get Aggregate Aux Record',
  DYNAMO_AUDIT: 'Get Audit Record',
  DYNAMO_IRE: 'Get IRE Risk Remediation Record',
  DYNAMO_DELETED: 'Get Deleted Record',
  DYNAMO_QUARANTINE: 'Get Quarantine Record',
  GRAPHQL_AGGREGATE: 'Get GraphQL Aggregate Data',
  GRAPHQL_CDB: 'Get GraphQL CDB Record',
  GRAPHQL_GPS: 'Get GraphQL GPS Record'
};
const getInitialSidebarWidth = () => {
  try {
    const saved = localStorage.getItem('sa_sidebar_width');
    if (saved) {
      const n = Number(saved);
      if (!isNaN(n)) return Math.min(_constants.SIDEBAR.MAX_WIDTH, Math.max(_constants.SIDEBAR.MIN_WIDTH, n));
    }
  } catch (_unused) {}
  return _constants.SIDEBAR.MIN_WIDTH;
};
const getInitialSidebarOpen = () => {
  try {
    if (sessionStorage.getItem('sa_sidebar_reopen')) {
      sessionStorage.removeItem('sa_sidebar_reopen');
      return true;
    }
  } catch (_unused2) {}
  return false;
};
const initialState = {
  threads: [],
  activeThreadId: null,
  activeFeature: null,
  isTyping: false,
  sidebarOpen: getInitialSidebarOpen(),
  sidebarWidth: getInitialSidebarWidth(),
  loadingMessages: _constants.DEFAULT_LOADING_MESSAGES,
  suggestions: [],
  feedbackOpen: false,
  feedbackMessageId: null,
  incidentStep: 0,
  incidentData: {
    idDesc: '',
    protectedInfo: ''
  },
  dataRetrievalStep: '',
  dataRetrievalType: '',
  dataRetrievalData: {}
};
const ACTION = Object.freeze({
  SET_THREADS: 'SET_THREADS',
  SET_ACTIVE_THREAD: 'SET_ACTIVE_THREAD',
  ADD_MESSAGE: 'ADD_MESSAGE',
  SET_TYPING: 'SET_TYPING',
  SET_FEATURE: 'SET_FEATURE',
  SET_SIDEBAR_OPEN: 'SET_SIDEBAR_OPEN',
  SET_SIDEBAR_WIDTH: 'SET_SIDEBAR_WIDTH',
  SET_LOADING_MSGS: 'SET_LOADING_MSGS',
  SET_SUGGESTIONS: 'SET_SUGGESTIONS',
  SET_FEEDBACK: 'SET_FEEDBACK',
  RESET_PATH: 'RESET_PATH',
  SET_INCIDENT_STEP: 'SET_INCIDENT_STEP',
  SET_DATA_RETRIEVAL: 'SET_DATA_RETRIEVAL',
  NEW_THREAD: 'NEW_THREAD',
  DELETE_THREAD: 'DELETE_THREAD',
  ARCHIVE_THREAD: 'ARCHIVE_THREAD',
  RENAME_THREAD: 'RENAME_THREAD'
});
function reducer(state, action) {
  var _action$payload$step, _action$payload$type, _action$payload$data, _action$payload$messa;
  switch (action.type) {
    case ACTION.SET_THREADS:
      return _objectSpread(_objectSpread({}, state), {}, {
        threads: action.payload
      });
    case ACTION.SET_ACTIVE_THREAD:
      return _objectSpread(_objectSpread({}, state), {}, {
        activeThreadId: action.payload
      });
    case ACTION.NEW_THREAD:
      {
        const t = action.payload;
        return _objectSpread(_objectSpread({}, state), {}, {
          threads: [t, ...state.threads],
          activeThreadId: t.id,
          activeFeature: t.featureType,
          suggestions: [],
          incidentStep: 0,
          incidentData: {
            idDesc: '',
            protectedInfo: ''
          },
          dataRetrievalStep: '',
          dataRetrievalType: '',
          dataRetrievalData: {}
        });
      }
    case ACTION.ADD_MESSAGE:
      {
        const {
          threadId,
          message
        } = action.payload;
        const threads = state.threads.map(t => {
          if (t.id !== threadId) return t;
          const msgs = [...t.messages, message];
          const updated = _objectSpread(_objectSpread({}, t), {}, {
            messages: msgs,
            updatedAt: new Date().toISOString()
          });
          if (!updated.title) updated.title = (0, _threadStore.autoTitle)(updated);
          (0, _threadStore.upsertThread)(updated);
          return updated;
        });
        return _objectSpread(_objectSpread({}, state), {}, {
          threads
        });
      }
    case ACTION.SET_TYPING:
      return _objectSpread(_objectSpread({}, state), {}, {
        isTyping: action.payload
      });
    case ACTION.SET_FEATURE:
      return _objectSpread(_objectSpread({}, state), {}, {
        activeFeature: action.payload
      });
    case ACTION.SET_SIDEBAR_OPEN:
      return _objectSpread(_objectSpread({}, state), {}, {
        sidebarOpen: action.payload
      });
    case ACTION.SET_SIDEBAR_WIDTH:
      return _objectSpread(_objectSpread({}, state), {}, {
        sidebarWidth: action.payload
      });
    case ACTION.SET_LOADING_MSGS:
      return _objectSpread(_objectSpread({}, state), {}, {
        loadingMessages: action.payload
      });
    case ACTION.RESET_PATH:
      return _objectSpread(_objectSpread({}, state), {}, {
        activeFeature: null,
        suggestions: [],
        incidentStep: 0,
        incidentData: {
          idDesc: '',
          protectedInfo: ''
        },
        dataRetrievalStep: '',
        dataRetrievalType: '',
        dataRetrievalData: {}
      });
    case ACTION.SET_INCIDENT_STEP:
      return _objectSpread(_objectSpread({}, state), {}, {
        incidentStep: action.payload.step,
        incidentData: action.payload.data || state.incidentData
      });
    case ACTION.SET_DATA_RETRIEVAL:
      return _objectSpread(_objectSpread({}, state), {}, {
        dataRetrievalStep: (_action$payload$step = action.payload.step) !== null && _action$payload$step !== void 0 ? _action$payload$step : state.dataRetrievalStep,
        dataRetrievalType: (_action$payload$type = action.payload.type) !== null && _action$payload$type !== void 0 ? _action$payload$type : state.dataRetrievalType,
        dataRetrievalData: (_action$payload$data = action.payload.data) !== null && _action$payload$data !== void 0 ? _action$payload$data : state.dataRetrievalData
      });
    case ACTION.SET_SUGGESTIONS:
      return _objectSpread(_objectSpread({}, state), {}, {
        suggestions: action.payload
      });
    case ACTION.SET_FEEDBACK:
      return _objectSpread(_objectSpread({}, state), {}, {
        feedbackOpen: action.payload.open,
        feedbackMessageId: (_action$payload$messa = action.payload.messageId) !== null && _action$payload$messa !== void 0 ? _action$payload$messa : null
      });
    case ACTION.DELETE_THREAD:
      {
        var _threads$;
        (0, _threadStore.deleteThread)(action.payload);
        const threads = state.threads.filter(t => t.id !== action.payload);
        const nextActive = state.activeThreadId === action.payload ? ((_threads$ = threads[0]) === null || _threads$ === void 0 ? void 0 : _threads$.id) || null : state.activeThreadId;
        return _objectSpread(_objectSpread({}, state), {}, {
          threads,
          activeThreadId: nextActive
        });
      }
    case ACTION.ARCHIVE_THREAD:
      {
        (0, _threadStore.archiveThread)(action.payload);
        const threads = state.threads.map(t => t.id === action.payload ? _objectSpread(_objectSpread({}, t), {}, {
          status: 'archived'
        }) : t);
        return _objectSpread(_objectSpread({}, state), {}, {
          threads
        });
      }
    case ACTION.RENAME_THREAD:
      {
        const {
          oldId,
          newId
        } = action.payload;
        const threads = state.threads.map(t => {
          if (t.id !== oldId) return t;
          const updated = _objectSpread(_objectSpread({}, t), {}, {
            id: newId,
            backendThreadId: newId
          });
          (0, _threadStore.upsertThread)(updated);
          return updated;
        });
        return _objectSpread(_objectSpread({}, state), {}, {
          threads,
          activeThreadId: state.activeThreadId === oldId ? newId : state.activeThreadId
        });
      }
    default:
      return state;
  }
}
const AssistantCtx = (0, _react.createContext)(null);
const useAssistant = () => (0, _react.useContext)(AssistantCtx);
exports.useAssistant = useAssistant;
function AssistantProvider(_ref) {
  let {
    children,
    goldenId: goldenIdProp,
    user
  } = _ref;
  const [state, dispatch] = (0, _react.useReducer)(reducer, initialState);
  const threadIdRef = (0, _react.useRef)(null);
  const activeThreadIdRef = (0, _react.useRef)(null);
  const goldenIdRef = (0, _react.useRef)(goldenIdProp || null);
  const [goldenId, _setGoldenId] = (0, _react.useState)(goldenIdProp || null);
  const setGoldenId = (0, _react.useCallback)(id => {
    goldenIdRef.current = id;
    _setGoldenId(id);
  }, []);
  const [_updatePageContext, setUpdatePageContext] = (0, _react.useState)(null);
  const updatePageContext = (0, _react.useCallback)(updates => {
    if (_updatePageContext) _updatePageContext(updates);
  }, [_updatePageContext]);
  const [firstName, setFirstName] = (0, _react.useState)('');
  const [userName, setUserName] = (0, _react.useState)('');
  (0, _react.useEffect)(() => {
    if (user !== null && user !== void 0 && user.firstName) {
      setFirstName(user.firstName);
      const full = user.lastName ? "".concat(user.firstName, " ").concat(user.lastName) : user.firstName;
      setUserName(full.trim());
      return;
    }
    try {
      const clientId = process.env.REACT_APP_USER_POOL_CLIENT_ID;
      if (!clientId) return;
      const userKey = localStorage.getItem("CognitoIdentityServiceProvider.".concat(clientId, ".LastAuthUser"));
      if (!userKey) return;
      const idToken = localStorage.getItem("CognitoIdentityServiceProvider.".concat(clientId, ".").concat(userKey, ".idToken"));
      if (!idToken) return;
      const payload = JSON.parse(atob(idToken.split('.')[1].replace(/-/g, '+').replace(/_/g, '/')));
      const rawName = payload.given_name || payload.name || '';
      let first = '';
      let last = '';
      if (rawName.includes(',')) {
        var _parts$;
        const parts = rawName.split(',').map(s => s.trim());
        last = parts[0] || '';
        first = ((_parts$ = parts[1]) === null || _parts$ === void 0 ? void 0 : _parts$.split(' ')[0]) || '';
      } else {
        const parts = rawName.split(' ').filter(Boolean);
        first = parts[0] || '';
        last = parts.length > 1 ? parts[parts.length - 1] : '';
      }
      setFirstName(first);
      setUserName(first && last ? "".concat(first, " ").concat(last) : first || last);
    } catch (_unused3) {}
  }, [user]);
  (0, _react.useEffect)(() => {
    if (goldenIdProp != null && goldenIdProp !== goldenIdRef.current) {
      setGoldenId(goldenIdProp);
    }
  }, [goldenIdProp, setGoldenId]);
  (0, _react.useEffect)(() => {
    const persisted = (0, _threadStore.loadThreads)(goldenIdRef.current);
    dispatch({
      type: ACTION.SET_THREADS,
      payload: persisted
    });
    if (persisted.length > 0) {
      activeThreadIdRef.current = persisted[0].id;
      threadIdRef.current = persisted[0].backendThreadId || null;
      dispatch({
        type: ACTION.SET_ACTIVE_THREAD,
        payload: persisted[0].id
      });
    } else {
      activeThreadIdRef.current = null;
      threadIdRef.current = null;
      dispatch({
        type: ACTION.SET_ACTIVE_THREAD,
        payload: null
      });
    }
  }, [goldenId]);
  const activeThread = state.threads.find(t => t.id === state.activeThreadId) || null;
  const activeFeature = (activeThread === null || activeThread === void 0 ? void 0 : activeThread.featureType) || state.activeFeature;
  const addMessage = (0, _react.useCallback)(function (role, text) {
    let extra = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    const tid = activeThreadIdRef.current || state.activeThreadId;
    if (!tid) return;
    dispatch({
      type: ACTION.ADD_MESSAGE,
      payload: {
        threadId: tid,
        message: _objectSpread({
          id: "msg_".concat(Date.now(), "_").concat(Math.random().toString(36).slice(2, 6)),
          role,
          text,
          createdAt: new Date().toISOString()
        }, extra)
      }
    });
  }, [state.activeThreadId]);
  const startNewThread = (0, _react.useCallback)(function () {
    let featureType = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    let context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const t = (0, _threadStore.createThread)({
      featureType,
      context: _objectSpread({
        eid: goldenId
      }, context)
    });
    (0, _threadStore.upsertThread)(t);
    threadIdRef.current = null;
    activeThreadIdRef.current = t.id;
    dispatch({
      type: ACTION.NEW_THREAD,
      payload: t
    });
    return t;
  }, [goldenId]);
  const switchThread = (0, _react.useCallback)(threadId => {
    activeThreadIdRef.current = threadId;
    dispatch({
      type: ACTION.SET_ACTIVE_THREAD,
      payload: threadId
    });
    const t = state.threads.find(th => th.id === threadId);
    threadIdRef.current = (t === null || t === void 0 ? void 0 : t.backendThreadId) || null;
  }, [state.threads]);
  const importThread = (0, _react.useCallback)(thread => {
    const exists = state.threads.some(t => t.id === thread.id);
    if (!exists) {
      dispatch({
        type: ACTION.SET_THREADS,
        payload: [thread, ...state.threads]
      });
    }
    activeThreadIdRef.current = thread.id;
    dispatch({
      type: ACTION.SET_ACTIVE_THREAD,
      payload: thread.id
    });
    threadIdRef.current = thread.backendThreadId || thread.id;
  }, [state.threads]);
  const deleteThread = (0, _react.useCallback)(threadId => {
    dispatch({
      type: ACTION.DELETE_THREAD,
      payload: threadId
    });
  }, []);
  const callBackend = (0, _react.useCallback)(async message => {
    try {
      const response = await (0, _api.sendSyncMessage)(message, threadIdRef.current);
      const data = await response.json();
      if (data.thread_id) {
        const prevBackendId = threadIdRef.current;
        threadIdRef.current = data.thread_id;
        const currentId = activeThreadIdRef.current || state.activeThreadId;
        if (!prevBackendId && currentId && currentId !== data.thread_id) {
          activeThreadIdRef.current = data.thread_id;
          dispatch({
            type: ACTION.RENAME_THREAD,
            payload: {
              oldId: currentId,
              newId: data.thread_id
            }
          });
        } else if (state.activeThreadId) {
          const t = state.threads.find(th => th.id === state.activeThreadId);
          if (t) {
            t.backendThreadId = data.thread_id;
            (0, _threadStore.upsertThread)(t);
          }
        }
      }
      return data;
    } catch (err) {
      console.error('SmartAssist backend error:', err);
      throw err;
    }
  }, [state.activeThreadId, state.threads]);
  const sendMessage = (0, _react.useCallback)(async function (text) {
    let featureOverride = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    if (!(text !== null && text !== void 0 && text.trim())) return;
    const input = text.trim();
    let tid = state.activeThreadId;
    if (featureOverride) {
      const t = startNewThread(featureOverride);
      tid = t.id;
    } else if (!tid) {
      const t = startNewThread(state.activeFeature);
      tid = t.id;
    }
    const feat = featureOverride || state.activeFeature;
    if (feat === _constants.FEATURES.INCIDENT_ANALYSIS || input === INCIDENT_PROMPTS.TRIGGER) {
      if (input.toLowerCase() === 'cancel') {
        addMessage(_constants.ROLES.USER, input);
        addMessage(_constants.ROLES.ASSISTANT, 'Incident analysis cancelled. You can start a new conversation or select another feature.');
        dispatch({
          type: ACTION.RESET_PATH
        });
        return;
      }
      if (state.incidentStep === 0) {
        if (feat !== _constants.FEATURES.INCIDENT_ANALYSIS) {
          dispatch({
            type: ACTION.SET_FEATURE,
            payload: _constants.FEATURES.INCIDENT_ANALYSIS
          });
        }
        addMessage(_constants.ROLES.USER, input);
        dispatch({
          type: ACTION.SET_INCIDENT_STEP,
          payload: {
            step: 1,
            data: {
              idDesc: '',
              protectedInfo: ''
            }
          }
        });
        dispatch({
          type: ACTION.SET_SUGGESTIONS,
          payload: []
        });
        addMessage(_constants.ROLES.ASSISTANT, 'Please provide the Incident ID and a brief description of the issue.\n\n' + 'Format: `<Incident ID> - <Description>`\n' + 'Example: INC123456 - User unable to login\n\n' + 'Note: Incident ID is optional.\n\n' + 'Type "cancel" to exit.');
        return;
      }
      if (state.incidentStep === 1) {
        addMessage(_constants.ROLES.USER, input);
        dispatch({
          type: ACTION.SET_INCIDENT_STEP,
          payload: {
            step: 2,
            data: _objectSpread(_objectSpread({}, state.incidentData), {}, {
              idDesc: input
            })
          }
        });
        addMessage(_constants.ROLES.ASSISTANT, 'For further analysis, please provide any protected information relevant to the incident. If none is available, enter **N/A**.');
        return;
      }
      if (state.incidentStep === 2) {
        addMessage(_constants.ROLES.USER, input);
        const incidentMessage = "Incident Info: ".concat(state.incidentData.idDesc, ". \nProtected Info: ").concat(input, "\n. EID: ").concat(goldenId);
        dispatch({
          type: ACTION.SET_LOADING_MSGS,
          payload: _constants.FEATURE_META[_constants.FEATURES.INCIDENT_ANALYSIS].loadingMessages
        });
        dispatch({
          type: ACTION.SET_TYPING,
          payload: true
        });
        try {
          const replyJson = await callBackend(incidentMessage);
          addMessage(_constants.ROLES.ASSISTANT, null, {
            json: replyJson,
            isAiGenerated: true
          });
        } catch (_unused4) {
          addMessage(_constants.ROLES.ASSISTANT, null, {
            json: {
              error: 'Incident analysis failed. Please try again.'
            }
          });
        } finally {
          dispatch({
            type: ACTION.SET_TYPING,
            payload: false
          });
          dispatch({
            type: ACTION.SET_INCIDENT_STEP,
            payload: {
              step: 0,
              data: {
                idDesc: '',
                protectedInfo: ''
              }
            }
          });
          dispatch({
            type: ACTION.RESET_PATH
          });
        }
        return;
      }
    }
    if (feat === _constants.FEATURES.DATA_RETRIEVAL || input === DATA_RETRIEVAL_PROMPTS.TRIGGER) {
      if (input.toLowerCase() === 'cancel') {
        addMessage(_constants.ROLES.USER, input);
        addMessage(_constants.ROLES.ASSISTANT, 'Data retrieval cancelled.');
        dispatch({
          type: ACTION.RESET_PATH
        });
        return;
      }
      const drStep = state.dataRetrievalStep;
      const drType = state.dataRetrievalType;
      if (input.toLowerCase() === 'back') {
        addMessage(_constants.ROLES.USER, input);
        if (drStep === 'validate_and_send') {
          const parentType = drType.startsWith('Get Dynamo') ? DATA_RETRIEVAL_PROMPTS.DYNAMO : drType.startsWith('Get GraphQL') ? DATA_RETRIEVAL_PROMPTS.GRAPHQL : '';
          if (parentType) {
            dispatch({
              type: ACTION.SET_DATA_RETRIEVAL,
              payload: {
                step: 'route_action',
                type: parentType,
                data: {}
              }
            });
            sendMessage(parentType, _constants.FEATURES.DATA_RETRIEVAL);
          } else {
            dispatch({
              type: ACTION.SET_DATA_RETRIEVAL,
              payload: {
                step: '',
                type: '',
                data: {}
              }
            });
            sendMessage(DATA_RETRIEVAL_PROMPTS.TRIGGER, _constants.FEATURES.DATA_RETRIEVAL);
          }
        } else if (drStep === 'route_action') {
          dispatch({
            type: ACTION.SET_DATA_RETRIEVAL,
            payload: {
              step: '',
              type: '',
              data: {}
            }
          });
          sendMessage(DATA_RETRIEVAL_PROMPTS.TRIGGER, _constants.FEATURES.DATA_RETRIEVAL);
        } else {
          addMessage(_constants.ROLES.ASSISTANT, 'You are already at the start. Please select an option or type cancel to exit.');
        }
        return;
      }
      if (!drStep || drStep === '' || input === DATA_RETRIEVAL_PROMPTS.TRIGGER) {
        if (feat !== _constants.FEATURES.DATA_RETRIEVAL) {
          dispatch({
            type: ACTION.SET_FEATURE,
            payload: _constants.FEATURES.DATA_RETRIEVAL
          });
        }
        addMessage(_constants.ROLES.USER, input);
        addMessage(_constants.ROLES.ASSISTANT, _AssistantResponseTexts.AssistantResponseTexts.DATA_RETRIEVAL());
        dispatch({
          type: ACTION.SET_SUGGESTIONS,
          payload: [DATA_RETRIEVAL_PROMPTS.CDC, DATA_RETRIEVAL_PROMPTS.USER_SERVICE, DATA_RETRIEVAL_PROMPTS.DYNAMO, DATA_RETRIEVAL_PROMPTS.GRAPHQL]
        });
        dispatch({
          type: ACTION.SET_DATA_RETRIEVAL,
          payload: {
            step: 'route_action',
            type: '',
            data: {}
          }
        });
        return;
      }
      if (drStep === 'route_action') {
        if (input === DATA_RETRIEVAL_PROMPTS.DYNAMO || drType === DATA_RETRIEVAL_PROMPTS.DYNAMO) {
          if (input === DATA_RETRIEVAL_PROMPTS.DYNAMO) {
            addMessage(_constants.ROLES.USER, input);
            addMessage(_constants.ROLES.ASSISTANT, _AssistantResponseTexts.AssistantResponseTexts.DATA_RETRIEVAL_DYNAMO_RECORD());
            dispatch({
              type: ACTION.SET_SUGGESTIONS,
              payload: [DATA_RETRIEVAL_PROMPTS.DYNAMO_PATIENT, DATA_RETRIEVAL_PROMPTS.DYNAMO_AGGREGATE, DATA_RETRIEVAL_PROMPTS.DYNAMO_RECORD_AUX, DATA_RETRIEVAL_PROMPTS.DYNAMO_AGGREGATE_AUX, DATA_RETRIEVAL_PROMPTS.DYNAMO_AUDIT, DATA_RETRIEVAL_PROMPTS.DYNAMO_IRE, DATA_RETRIEVAL_PROMPTS.DYNAMO_DELETED, DATA_RETRIEVAL_PROMPTS.DYNAMO_QUARANTINE]
            });
            dispatch({
              type: ACTION.SET_DATA_RETRIEVAL,
              payload: {
                step: 'route_action',
                type: DATA_RETRIEVAL_PROMPTS.DYNAMO
              }
            });
            return;
          }
          const dynamoSubTypeAssistantText = {
            [DATA_RETRIEVAL_PROMPTS.DYNAMO_PATIENT]: _AssistantResponseTexts.AssistantResponseTexts.DYNAMO_SELECT_RECORD_TYPE_LONG('Patient Record', 'SourceId|RecordId'),
            [DATA_RETRIEVAL_PROMPTS.DYNAMO_AGGREGATE]: _AssistantResponseTexts.AssistantResponseTexts.DYNAMO_SELECT_RECORD_TYPE_SHORT('Aggregate Record', 'EID'),
            [DATA_RETRIEVAL_PROMPTS.DYNAMO_RECORD_AUX]: _AssistantResponseTexts.AssistantResponseTexts.DYNAMO_SELECT_RECORD_TYPE_LONG('Record Aux Record', 'SourceId|RecordId'),
            [DATA_RETRIEVAL_PROMPTS.DYNAMO_AGGREGATE_AUX]: _AssistantResponseTexts.AssistantResponseTexts.DYNAMO_SELECT_RECORD_TYPE_SHORT('Aggregate Aux Record', 'EID'),
            [DATA_RETRIEVAL_PROMPTS.DYNAMO_AUDIT]: _AssistantResponseTexts.AssistantResponseTexts.DYNAMO_SELECT_RECORD_TYPE_CORRELATION_ID('Audit Record'),
            [DATA_RETRIEVAL_PROMPTS.DYNAMO_IRE]: _AssistantResponseTexts.AssistantResponseTexts.DYNAMO_SELECT_RECORD_TYPE_SHORT('IRE Risk Remediation Record', 'EID'),
            [DATA_RETRIEVAL_PROMPTS.DYNAMO_DELETED]: _AssistantResponseTexts.AssistantResponseTexts.DYNAMO_SELECT_RECORD_TYPE_LONG('Deleted Record', 'SourceId|RecordId'),
            [DATA_RETRIEVAL_PROMPTS.DYNAMO_QUARANTINE]: _AssistantResponseTexts.AssistantResponseTexts.DYNAMO_SELECT_RECORD_TYPE_LONG('Quarantine Record', 'SourceId|RecordId')
          };
          addMessage(_constants.ROLES.USER, input);
          addMessage(_constants.ROLES.ASSISTANT, dynamoSubTypeAssistantText[input] || _AssistantResponseTexts.AssistantResponseTexts.DYNAMO_SELECT_RECORD_TYPE_LONG(input.replace('Get ', ''), 'SourceId|RecordId'));
          dispatch({
            type: ACTION.SET_SUGGESTIONS,
            payload: []
          });
          dispatch({
            type: ACTION.SET_DATA_RETRIEVAL,
            payload: {
              step: 'validate_and_send',
              type: input
            }
          });
          return;
        }
        if (input === DATA_RETRIEVAL_PROMPTS.GRAPHQL || drType === DATA_RETRIEVAL_PROMPTS.GRAPHQL) {
          if (input === DATA_RETRIEVAL_PROMPTS.GRAPHQL) {
            addMessage(_constants.ROLES.USER, input);
            addMessage(_constants.ROLES.ASSISTANT, _AssistantResponseTexts.AssistantResponseTexts.DATA_RETRIEVAL_GRAPHQL());
            dispatch({
              type: ACTION.SET_SUGGESTIONS,
              payload: [DATA_RETRIEVAL_PROMPTS.GRAPHQL_AGGREGATE, DATA_RETRIEVAL_PROMPTS.GRAPHQL_CDB, DATA_RETRIEVAL_PROMPTS.GRAPHQL_GPS]
            });
            dispatch({
              type: ACTION.SET_DATA_RETRIEVAL,
              payload: {
                step: 'route_action',
                type: DATA_RETRIEVAL_PROMPTS.GRAPHQL
              }
            });
            return;
          }
          const graphQLSubTypeAssistantText = {
            [DATA_RETRIEVAL_PROMPTS.GRAPHQL_AGGREGATE]: _AssistantResponseTexts.AssistantResponseTexts.DATA_RETRIEVAL_GRAPHQL_SHORT('aggregate', 'EID'),
            [DATA_RETRIEVAL_PROMPTS.GRAPHQL_GPS]: _AssistantResponseTexts.AssistantResponseTexts.DATA_RETRIEVAL_GRAPHQL_SHORT('record', 'GPS Household Identifier'),
            [DATA_RETRIEVAL_PROMPTS.GRAPHQL_CDB]: _AssistantResponseTexts.AssistantResponseTexts.DATA_RETRIEVAL_GRAPHQL_LONG('record', 'CDB Record ID')
          };
          addMessage(_constants.ROLES.USER, input);
          addMessage(_constants.ROLES.ASSISTANT, graphQLSubTypeAssistantText[input] || _AssistantResponseTexts.AssistantResponseTexts.DATA_RETRIEVAL_GRAPHQL_SHORT(input.replace('Get ', ''), 'EID'));
          dispatch({
            type: ACTION.SET_SUGGESTIONS,
            payload: []
          });
          dispatch({
            type: ACTION.SET_DATA_RETRIEVAL,
            payload: {
              step: 'validate_and_send',
              type: input
            }
          });
          return;
        }
        if (input === DATA_RETRIEVAL_PROMPTS.CDC) {
          addMessage(_constants.ROLES.USER, input);
          addMessage(_constants.ROLES.ASSISTANT, _AssistantResponseTexts.AssistantResponseTexts.DATA_RETRIEVAL_RECORD_LONG('CDC', 'SourceId|RecordId'));
          dispatch({
            type: ACTION.SET_SUGGESTIONS,
            payload: []
          });
          dispatch({
            type: ACTION.SET_DATA_RETRIEVAL,
            payload: {
              step: 'validate_and_send',
              type: DATA_RETRIEVAL_PROMPTS.CDC
            }
          });
          return;
        }
        if (input === DATA_RETRIEVAL_PROMPTS.USER_SERVICE) {
          addMessage(_constants.ROLES.USER, input);
          addMessage(_constants.ROLES.ASSISTANT, _AssistantResponseTexts.AssistantResponseTexts.DATA_RETRIEVAL_USER_SERVICE_SHORT());
          dispatch({
            type: ACTION.SET_SUGGESTIONS,
            payload: []
          });
          dispatch({
            type: ACTION.SET_DATA_RETRIEVAL,
            payload: {
              step: 'validate_and_send',
              type: DATA_RETRIEVAL_PROMPTS.USER_SERVICE
            }
          });
          return;
        }
        addMessage(_constants.ROLES.USER, input);
        addMessage(_constants.ROLES.ASSISTANT, 'Invalid selection. Please choose from the options above or type cancel to exit.');
        return;
      }
      if (drStep === 'validate_and_send') {
        var _user$preferences;
        const clientId = (user === null || user === void 0 || (_user$preferences = user.preferences) === null || _user$preferences === void 0 || (_user$preferences = _user$preferences.selectedClient) === null || _user$preferences === void 0 ? void 0 : _user$preferences.oid) || '';
        const focusEid = goldenId || '';
        let request = '';
        const requestMap = {
          [DATA_RETRIEVAL_PROMPTS.CDC]: "get CDC record for ".concat(input),
          [DATA_RETRIEVAL_PROMPTS.USER_SERVICE]: "get userService record for EID ".concat(input),
          [DATA_RETRIEVAL_PROMPTS.DYNAMO_PATIENT]: "get Dynamo patient record for ".concat(clientId, "|").concat(input),
          [DATA_RETRIEVAL_PROMPTS.DYNAMO_AGGREGATE]: "get Dynamo aggregate record for ".concat(clientId, "|").concat(input),
          [DATA_RETRIEVAL_PROMPTS.DYNAMO_RECORD_AUX]: "get Dynamo record aux record for ".concat(clientId, "|").concat(input),
          [DATA_RETRIEVAL_PROMPTS.DYNAMO_AGGREGATE_AUX]: "get Dynamo aggregate aux record for ".concat(clientId, "|").concat(input),
          [DATA_RETRIEVAL_PROMPTS.DYNAMO_AUDIT]: "get Dynamo audit record for ".concat(clientId, "|").concat(input),
          [DATA_RETRIEVAL_PROMPTS.DYNAMO_IRE]: "get Dynamo IRE risk remediation record for ".concat(clientId, "|").concat(input),
          [DATA_RETRIEVAL_PROMPTS.DYNAMO_DELETED]: "get Dynamo deleted record for ".concat(clientId, "|").concat(input),
          [DATA_RETRIEVAL_PROMPTS.DYNAMO_QUARANTINE]: "get Dynamo quarantine record for ".concat(clientId, "|").concat(input),
          [DATA_RETRIEVAL_PROMPTS.GRAPHQL_AGGREGATE]: "get graphQl record for EID ".concat(input),
          [DATA_RETRIEVAL_PROMPTS.GRAPHQL_GPS]: "get graphQl GPS Eligibility record with householdIdentifier ".concat(input),
          [DATA_RETRIEVAL_PROMPTS.GRAPHQL_CDB]: "get graphQl CDB Eligibility for ".concat(input)
        };
        request = requestMap[drType] || "get data for ".concat(input, " for EID ").concat(focusEid);
        addMessage(_constants.ROLES.USER, input);
        dispatch({
          type: ACTION.SET_LOADING_MSGS,
          payload: _constants.FEATURE_META[_constants.FEATURES.DATA_RETRIEVAL].loadingMessages
        });
        dispatch({
          type: ACTION.SET_TYPING,
          payload: true
        });
        try {
          const replyJson = await callBackend(request);
          addMessage(_constants.ROLES.ASSISTANT, null, {
            json: replyJson,
            dataRetrievalType: drType,
            requestText: request,
            isAiGenerated: true
          });
        } catch (_unused5) {
          addMessage(_constants.ROLES.ASSISTANT, null, {
            json: {
              error: 'Data retrieval failed. Please try again.'
            }
          });
        } finally {
          dispatch({
            type: ACTION.SET_TYPING,
            payload: false
          });
        }
        dispatch({
          type: ACTION.SET_SUGGESTIONS,
          payload: [DATA_RETRIEVAL_PROMPTS.CDC, DATA_RETRIEVAL_PROMPTS.USER_SERVICE, DATA_RETRIEVAL_PROMPTS.DYNAMO, DATA_RETRIEVAL_PROMPTS.GRAPHQL]
        });
        dispatch({
          type: ACTION.SET_DATA_RETRIEVAL,
          payload: {
            step: 'route_action',
            type: '',
            data: {}
          }
        });
        addMessage(_constants.ROLES.ASSISTANT, _AssistantResponseTexts.AssistantResponseTexts.RETRIEVE_ANOTHER_RECORD());
        return;
      }
    }
    addMessage(_constants.ROLES.USER, input);
    const msgs = feat && _constants.FEATURE_META[feat] ? _constants.FEATURE_META[feat].loadingMessages : _constants.DEFAULT_LOADING_MESSAGES;
    dispatch({
      type: ACTION.SET_LOADING_MSGS,
      payload: msgs
    });
    dispatch({
      type: ACTION.SET_TYPING,
      payload: true
    });
    dispatch({
      type: ACTION.SET_SUGGESTIONS,
      payload: []
    });
    try {
      const fullMsg = goldenId ? "".concat(input, "\n. EID: ").concat(goldenId) : input;
      const replyJson = await callBackend(fullMsg);
      addMessage(_constants.ROLES.ASSISTANT, null, {
        json: replyJson,
        isAiGenerated: true
      });
    } catch (_unused6) {
      addMessage(_constants.ROLES.ASSISTANT, null, {
        json: {
          error: 'Something went wrong. Please try again.'
        }
      });
    } finally {
      dispatch({
        type: ACTION.SET_TYPING,
        payload: false
      });
    }
  }, [state.activeThreadId, state.activeFeature, state.incidentStep, state.incidentData, state.dataRetrievalStep, state.dataRetrievalType, addMessage, callBackend, goldenId, user, startNewThread]);
  const setFeature = (0, _react.useCallback)(f => {
    dispatch({
      type: ACTION.SET_FEATURE,
      payload: f
    });
  }, []);
  const setSidebarOpen = (0, _react.useCallback)(v => {
    dispatch({
      type: ACTION.SET_SIDEBAR_OPEN,
      payload: v
    });
  }, []);
  const setSidebarWidth = (0, _react.useCallback)(w => {
    dispatch({
      type: ACTION.SET_SIDEBAR_WIDTH,
      payload: w
    });
  }, []);
  const setSuggestions = (0, _react.useCallback)(s => {
    dispatch({
      type: ACTION.SET_SUGGESTIONS,
      payload: s
    });
  }, []);
  const openFeedback = (0, _react.useCallback)(function () {
    let messageId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    dispatch({
      type: ACTION.SET_FEEDBACK,
      payload: {
        open: true,
        messageId
      }
    });
  }, []);
  const closeFeedback = (0, _react.useCallback)(() => {
    dispatch({
      type: ACTION.SET_FEEDBACK,
      payload: {
        open: false,
        messageId: null
      }
    });
  }, []);
  const resetPath = (0, _react.useCallback)(() => {
    dispatch({
      type: ACTION.RESET_PATH
    });
  }, []);
  const convertMessage = (0, _react.useCallback)(msg => {
    const textContent = msg.text || '';
    const jsonContent = msg.json;
    let content = textContent;
    if (jsonContent && !textContent) {
      if (jsonContent.error) {
        content = typeof jsonContent.error === 'string' ? jsonContent.error : 'Something went wrong.';
      } else {
        var _jsonContent$message, _jsonContent$message2, _jsonContent$message3;
        const result = (jsonContent === null || jsonContent === void 0 || (_jsonContent$message = jsonContent.message) === null || _jsonContent$message === void 0 || (_jsonContent$message = _jsonContent$message.data_correction) === null || _jsonContent$message === void 0 ? void 0 : _jsonContent$message.result) || (jsonContent === null || jsonContent === void 0 || (_jsonContent$message2 = jsonContent.message) === null || _jsonContent$message2 === void 0 || (_jsonContent$message2 = _jsonContent$message2.entity_summary) === null || _jsonContent$message2 === void 0 ? void 0 : _jsonContent$message2.result) || (jsonContent === null || jsonContent === void 0 || (_jsonContent$message3 = jsonContent.message) === null || _jsonContent$message3 === void 0 ? void 0 : _jsonContent$message3.result) || (jsonContent === null || jsonContent === void 0 ? void 0 : jsonContent.message);
        content = typeof result === 'string' ? result : JSON.stringify(result, null, 2);
      }
    }
    return {
      role: msg.role === _constants.ROLES.USER ? 'user' : 'assistant',
      content: content || '',
      id: msg.id,
      createdAt: new Date(msg.createdAt)
    };
  }, []);
  const auiMessages = (0, _react.useMemo)(() => (activeThread === null || activeThread === void 0 ? void 0 : activeThread.messages) || [], [activeThread === null || activeThread === void 0 ? void 0 : activeThread.messages]);
  const runtime = (0, _react2.useExternalStoreRuntime)({
    isRunning: state.isTyping,
    messages: auiMessages,
    convertMessage,
    onNew: undefined,
    onCancel: undefined,
    adapters: {
      threadList: {
        threadId: state.activeThreadId,
        threads: state.threads.filter(t => t.status !== 'archived').map(t => ({
          id: t.id,
          title: (0, _threadStore.autoTitle)(t),
          status: 'regular'
        })),
        archivedThreads: state.threads.filter(t => t.status === 'archived').map(t => ({
          id: t.id,
          title: (0, _threadStore.autoTitle)(t),
          status: 'archived'
        })),
        onSwitchToNewThread: () => {
          resetPath();
          startNewThread();
        },
        onSwitchToThread: threadId => {
          switchThread(threadId);
        },
        onDelete: threadId => {
          deleteThread(threadId);
        }
      }
    }
  });
  const value = _objectSpread(_objectSpread({}, state), {}, {
    activeThread,
    activeFeature,
    goldenId,
    setGoldenId,
    updatePageContext,
    setUpdatePageContext,
    firstName,
    userName,
    user,
    threadIdRef,
    startNewThread,
    switchThread,
    importThread,
    deleteThread,
    addMessage,
    sendMessage,
    setFeature,
    setSidebarOpen,
    setSidebarWidth,
    setSuggestions,
    openFeedback,
    closeFeedback,
    resetPath,
    callBackend,
    dispatch,
    ACTION
  });
  return (0, _jsxRuntime.jsx)(_react2.AssistantRuntimeProvider, {
    runtime: runtime,
    children: (0, _jsxRuntime.jsx)(AssistantCtx.Provider, {
      value: value,
      children: children
    })
  });
}